// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "vimeoPlayer" + "." + "c84d0e8795cc7b43" + ".js"
}